import {baseDeleteRequest} from "../base/baseDeleteRequest";

const deleteScreenshot = async (id_device: number, id_screenshot: number) =>
  baseDeleteRequest(`/device/${id_device}/screenshot/${id_screenshot}/`);

export default deleteScreenshot;
